(function () {
  /**
   * @ngdoc module
   * @name app.widgets.products.product-all-usage
   * @description module that defines product-all-usage widgets
   */
  angular.module('app.widgets.products.product-all-usage', [
    'app.core.products.usage',
    'app.widgets.products.product-segment-usage',
    'binky.core.feature',
    'binky.core.lodash',
    'binky.core.offers',
    'rcServices.user',
  ]);
})();
